export default function timeToPrice(milliseconds, pricingModel = 'pay_as_go', pricingPlan = null, holds = []) {
  let price = 0;
  let seconds = parseInt((milliseconds / 1000).toFixed());
  let minutes = Math.ceil(seconds / 60);

  price += holds.map(hold => {
    if ('hold_cost' in hold) {
      return hold.hold_cost;
    }
    const complete = hold.completed_at ? new Date(hold.completed_at).getTime() : new Date().getTime();
    const start = new Date(hold.started_at).getTime();
    return (complete - start) / 1000 > hold.trial_time ? hold.period_amount : 0
  }).reduce((a, b) => a + b, 0);  

  if (pricingPlan) {
    let { unlock_fee_amount, period_amount, period } = pricingPlan;
    price += unlock_fee_amount + period_amount * Math.ceil(seconds / period);
    return parseFloat((price / 100).toFixed(2));
  }

  if (pricingModel === 'pay_as_go') {
    price += 100 + parseInt((minutes * 25).toFixed());
  } else if (pricingModel === '42_minute_pass') {
    price += 699 * Math.ceil(Math.max(minutes, 1) / 41);
  } else if (pricingModel === '42_minute_pass_999') {
    price += 999 * Math.ceil(Math.max(minutes, 1) / 41);
  }

  price = parseFloat((price / 100).toFixed(2));
  return price;
}